import { get, IHttpResponse } from './BackendService';
import { DEX_URL } from '../app-config';
import { DexRatingScoreResponse } from '../interfaces/dex';

export const getRatingScore = async (
  rating: string,
): Promise<IHttpResponse<DexRatingScoreResponse>> =>
  get<DexRatingScoreResponse>(`${DEX_URL}/api/v3/score/${encodeURIComponent(rating)}`);
